<mat-card class="pos-relative group-wrap rounded-inherit">
	<mat-card-title-group class="group-header flex flex-row items-start justify-start">
		<mat-card-title class="group-date">{{ data.date | dfnsFormat: 'iiii' }}</mat-card-title>
		<mat-card-subtitle class="group-date-full">{{ data.date | formatDate: 'PP' }}</mat-card-subtitle>
		<div class="flex-auto"></div>
		<div
			*ngIf="{
        schedule: (schedule$ | async),
        stats: (data$stats | async),
      } as info"
			class="flex items-center space-x-6"
		>
			<ng-container>
				<ng-container *ngIf="info.schedule as sched">
					<ng-container
						*ngTemplateOutlet="
              scheduleView;
              context: {
                $implicit: sched,
                isProjectTab: !(comegoEnabled$ | async),
              }
            "
					></ng-container>
				</ng-container>
				<div
					*ngIf="info.schedule && info.stats"
					class="mat-bg-5 h-8 w-px"
				></div>
			</ng-container>
			<div
				*ngIf="info.stats as item"
				class="flex cursor-default flex-col"
			>
				<small [matTooltip]=" 'time.plural' | translate ">
					<strong> {{ item?.timeSum ?? 0 | parseMsAsDuration: false }}</strong>
				</small>
				<small
					[matTooltip]=" 'Billable'| translate "
					class="mat-hint mat-text-accent"
				>
					{{ (item.billable ? item.billable : 0) | parseMsAsDuration: false }}</small
				>
			</div>
		</div>
	</mat-card-title-group>
	<mat-card-content class="--table-time-container">
		<div class="group-content group-content-scroll flex flex-col items-stretch justify-start gap-2">
			<ng-container *ngTemplateOutlet="template"></ng-container>
		</div>
	</mat-card-content>
</mat-card>
<ng-template
	#scheduleView
	let-isProjectTab="isProjectTab"
	let-sched
>
	<div
		[matTooltipDisabled]="!isProjectTab"
		[matTooltipTemplate]="scheduleTooltip"
		[matTooltipTemplateContext]="{ $implicit: sched }"
		[ngClass]="{ 'grid-cols-[1fr_28px]': isProjectTab }"
		class="mat-typography mat-bg-5-hover grid h-12 items-center gap-x-6 rounded-lg px-4"
		matTooltip
	>
		<div
			[ngClass]="{ 'text-sm': isProjectTab }"
			class="flex flex-col text-right"
		>
			<span>{{ sched.usage | parseMsAsDuration }}</span>
			<span *ngIf="isProjectTab">{{ sched.cap | parseMsAsDuration }}</span>
		</div>
		<div
			*ngIf="isProjectTab"
			class="mat-circle-card"
		>
			<mat-progress-spinner
				[color]="sched.graphState"
				[diameter]="20"
				[value]="sched.percent * 100 | clamp: 0 : 100"
				class="with-back-spinner"
				strokeWidth="3"
			></mat-progress-spinner>
		</div>
	</div>
</ng-template>
<ng-template
	#scheduleTooltip
	let-sched
>
	<div class="mat-typography flex flex-col px-3 py-2.5">
		<div class="flex items-center space-x-2">
			<span>{{ sched.name || ('schedules.name' | translate) }}</span>
			<ng-container *ngIf="sched.percent >= 0">
				<span class="dot size-1.5"></span>
				<span>{{ sched.percent | percent }}</span>
			</ng-container>
		</div>
	</div>
</ng-template>
<!-- <ng-template #blockEdit>
  <div class="flex flex-col space-y-2">
    <div>{{ 'time.blockEdit' | translate }}</div>
  </div>
</ng-template> -->
